import { createSelector } from "reselect";

import { Right } from "constants/right";
import { alphabeticalSortBySelector } from "helpers/sort";
import { IStoreState } from "interfaces/storeState";
import { IMailbox } from "store/entities/mailboxes/interfaces";
import { IEntityCollectionState } from "store/entities/reducer";
import { hasRight } from "store/features/session";
import { createRequestFetchingSelector } from "store/requests/selectors";

import { MailboxesRequestActions } from "./actions";

export interface IWithMailboxesState {
  entities: {
    mailboxes: IEntityCollectionState<IMailbox>;
  };
}

export function selectMailboxes(state: IWithMailboxesState): IEntityCollectionState<IMailbox> {
  return state.entities.mailboxes;
}

export function selectMailbox(state: IWithMailboxesState, id: string): IMailbox | undefined {
  return selectMailboxes(state)[id];
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectMailboxesCount = createSelector(selectMailboxes, (mailboxes: any) => Object.keys(mailboxes).length);

export const selectMailboxesAlphabetically = createSelector(selectMailboxes, mailbox =>
  Object.values(mailbox).sort(alphabeticalSortBySelector(view => view.name))
);

export const selectTakenMailboxNames = createSelector(
  selectMailboxes,
  // @ts-expect-error TS(2571): Object is of type 'unknown'.
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (views: any) => new Set(Object.values(views).map(mailbox => mailbox.name))
);

export const selectCanManageCustomMailboxes = (state: IStoreState): boolean =>
  hasRight(state, Right.ManageCustomMailboxes);

export const selectIsUpdatingDefaultMailbox = createRequestFetchingSelector([
  MailboxesRequestActions.UPDATE_DEFAULT_MAILBOX_REQUEST,
]);

export const selectIsUpdatingMailbox = createRequestFetchingSelector([
  MailboxesRequestActions.UPDATE_MAILBOXES_REQUEST,
]);

export const selectIsCreatingMailbox = createRequestFetchingSelector([
  MailboxesRequestActions.CREATE_MAILBOXES_REQUEST,
]);

export const selectIsDeletingMailbox = createRequestFetchingSelector([
  MailboxesRequestActions.DELETE_MAILBOXES_REQUEST,
]);

export const selectIsMailboxesFetching = createRequestFetchingSelector([MailboxesRequestActions.FETCH_COLLECTION]);
